import utils from '@/mixins/utils.js'

/**
 * Campos para o relatório em XLS
 *
 * @param {*} selectedEstabelecimento
 * @returns {Object}
 */
export function buildDataFields(selectedEstabelecimento = null) {
  const labelCnes = ` ${
    selectedEstabelecimento?.no_unidade_saude?.split(' ')[0] || ''
  }`

  return {
    Nome: 'no_cidadao',
    'Data de nascimento': {
      callback: (item) => {
        return item.dt_nascimento != null
          ? utils.methods.formatDate(item.dt_nascimento)
          : ''
      },
    },
    Mãe: 'no_mae',
    Atendimento: {
      callback: (item) => {
        return item.dt_ult_atendimento != null
          ? utils.methods.formatDate(item.dt_ult_atendimento)
          : ''
      },
    },
    [labelCnes]: {
      callback: (item) => {
        return item.color === 'red'
          ? Number(item.qtd_atends_us_selecionada_7dias || 0)
          : Number(item.qtd_atends_us_selecionada || 0)
      },
    },
    Outros: 'qtd_atends_us_outras',
    CPF: {
      field: 'nu_cpf',
      callback: (value) => {
        return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
      },
    },
    CNS: {
      field: 'nu_cns',
      callback: (value) => {
        return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
      },
    },
    Equipe: {
      field: 'ine_fci',
      callback: (value) => {
        return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
      },
    },
    Microárea: {
      field: 'micro_area',
      callback: (value) => {
        return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
      },
    },
    'Cadastrado por': 'no_profissional',
  }
}

export const infoHtml = ``
